<div class="content">
  <div class="content-panel">
    <div class="d-flex justify-content-between flex-start p-3">
      <p-button label="{{ 'page.edition.generation-documents.exporter-habilitations' | translate }}" (click)="exporterHabilitations()" (keydown.enter)="exporterHabilitations()"></p-button>
      <button class="btn btn-outline-primary d-flex align-items-center gap-2"
              (click)="openColumnModal()">
        <fa-icon icon="columns"></fa-icon>
        <span>Colonnes</span>
        <span class="badge bg-primary text-white ms-2">{{ getVisibleColumnCount() }} / {{ columns.length }}</span>
      </button>
    </div>

    <!--- Tableau --->
    @if (filteredHabilitations.length > 0) {
      <div >
        {{ dt?.filteredValue?.length ?? filteredHabilitations.length }}
        / {{ filteredHabilitations.length }}
      </div>
      <p-table
        #dt
        [value]="filteredHabilitations"
        [paginator]="true"
        [rows]="30"
        [scrollable]="true"
        scrollHeight="calc(100vh - 250px)">
        <ng-template pTemplate="header">
          <tr>
            @for (col of columns; track col) {
              <th scope="col" [pSortableColumn]="col.field" [hidden]="!col.visible" [style.width]="col.width">
                {{ col.label | translate }}
                <p-sortIcon [field]="col.field" />
                @if (col.filter === 'habilitation') {
                  <p-columnFilter field="{{ col.field }}" matchMode="in" display="menu" [showOperator]="false" [showMatchModes]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-multiselect [options]="typeHabilitations"
                                     (onChange)="filter($event.value)"
                                     [ngModel]="value"
                                     [filter]="false"
                                     placeholder="Sélectionner un état"
                                     optionLabel="name"
                                     optionValue="name"
                                     display="chip">
                      </p-multiselect>
                    </ng-template>
                  </p-columnFilter>
                } @else if (col.filter === 'activite') {
                  <p-columnFilter field="{{ col.field }}" matchMode="equals" display="menu" [showOperator]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-select [options]="typeActivites"
                                (onChange)="filter($event.value)"
                                [ngModel]="value"
                                placeholder="Sélectionner une activité"
                                [showClear]="true"
                                optionLabel="name"
                                optionValue="name">
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                } @else if (col.filter === 'cahier') {
                  <p-columnFilter field="{{ col.field }}" matchMode="equals" display="menu" [showOperator]="false">
                    <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                      <p-select [options]="typeCahiers"
                                (onChange)="filter($event.value)"
                                [ngModel]="value"
                                placeholder="Sélectionner un cahier des charges"
                                [showClear]="true"
                                optionLabel="name"
                                optionValue="code">
                      </p-select>
                    </ng-template>
                  </p-columnFilter>
                } @else {
                <p-columnFilter type="{{ col.filter }}" field="{{ col.field }}" display="menu" [showOperator]="false" />
              }
              </th>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-habilitation>
          <tr>
              @for (col of columns; track col) {
                  <td [hidden]="!col.visible" [style.width]="col.width">
                      {{ getFieldValue(habilitation, col.field) }}
                  </td>
              }
          </tr>
        </ng-template>
      </p-table>
    }


    @if (filteredHabilitations.length === 0) {
      <ng-container *ngTemplateOutlet="aucunHistorique"></ng-container>
    }

    <!-- Modale colonnes -->
    <ng-template #columnModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title">Sélection des colonnes</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
      </div>

      <div class="modal-body">
        @if (getVisibleColumnCount() >= 5) {
          <div class="alert alert-info py-2">
            <small>Vous avez atteint la limite de 5 colonnes affichées.</small>
          </div>
        }
        @for (col of columns; track col.field) {
          <div class="form-check">
            <input class="form-check-input" type="checkbox" [checked]="col.visible" (change)="toggleColumnVisibility(col.field)" id="{{col.field}}" [disabled]="!col.visible && getVisibleColumnCount() >= 5">
            <label class="form-check-label" [for]="col.field">
              {{ col.label }}
            </label>
          </div>
        }
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.close()">Fermer</button>
      </div>
    </ng-template>


    <!-- Template aucun historique -->
    <ng-template #aucunHistorique>
      <div class="alert alert-warning alert-block" translate>
        <fa-icon icon="exclamation"></fa-icon> page.declarations.suivi-parcellaires-viticoles.aucunHistorique
      </div>
    </ng-template>
    <!-- Fin template aucun historique -->
  </div>
</div>
